import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../../../services/website-theme.service";
let WelcomeToStakingComponent = class WelcomeToStakingComponent {
    constructor(sanitizer, location, themeService) {
        this.sanitizer = sanitizer;
        this.location = location;
        this.themeService = themeService;
        this.errorColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.acceptConditions = false;
        this.acceptRisks = false;
        this.buttonClicked = false;
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    confirmConditions() {
        if (!this.acceptConditions || !this.acceptRisks) {
            return;
        }
        this.success();
        this.close();
    }
};
WelcomeToStakingComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: LocationStrategy },
    { type: WebsiteThemeService }
];
WelcomeToStakingComponent = __decorate([
    Component({
        selector: 'ecd-welcome-to-staking',
        template: __importDefault(require("./welcome-to-staking.component.html")).default,
    })
], WelcomeToStakingComponent);
export { WelcomeToStakingComponent };
